import MiniMasonry from "minimasonry";

// Recupero tutti i .block-masonry
let blocks = document.querySelectorAll('.block-masonry');

// Per ogni blocco
blocks.forEach(block => {
    // Recupero il container
    let container = block.querySelector('.masonry-gallery');
    // Creo una nuova istanza di MiniMasonry
    let masonry = new MiniMasonry({
        container: container,
        minify: true,
        surroundingGutter: false
    });
});